/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import React, { memo, useEffect, useState } from "react"
import { useLocation } from "@reach/router"
import { useBlogMetaData } from "../queries/useBlogMetaData"
import { LocalBusiness } from "../LocalBusinessSchema"
import { useHomeNewMetadata } from "../queries/useHomeNewMetaData"

const Seo = ({
  lang,
  meta,
  seoData,
  schemaMarkup,
  faqSchema,
  bannerImage,
  // tagScript,
  // clarityScript,
  blogSchema,
}) => {
  // const keyword = (detail && detail[0]?.seo_focuskeywords !== '') && JSON?.parse(detail[0]?.seo_focuskeywords)[0]?.keyword

  const trackingIdForHireAndDedicatedPage =
    process.env.GATSBY_GOOGLE_TAG_TRACK_ID

  const homeData = useHomeNewMetadata()
  const { ogTagText } = homeData?.wp?.myThemeOptionsSettings
  const location = useLocation()

  // const metaDescription = description || seoData?.metaDesc
  // const defaultTitle = seoData?.title
  const schemaAsString = JSON.stringify(schemaMarkup, null, 2)

  // Because we are getting null as string from query
  let faqSchemaString = faqSchema === "null" ? "" : faqSchema
  var faqJson = JSON.stringify(faqSchemaString, function (key, value) {
    if (typeof value === "string") {
      return value.replace(/\n/g, "")
    }
    return value
  })

  const blogData = useBlogMetaData()
  const { generalSettingsUrl } = blogData?.wp?.allSettings

  const blogMeta = location?.pathname?.includes("/blogs/")
    ? location?.pathname?.split("/")
    : ""

  const [metaTagsArr, setMetaTagsArr] = useState([
    {
      property: `og:title`,
      content: seoData?.customSeoMetaTitle ? seoData?.customSeoMetaTitle : "",
    },
    {
      property: `og:description`,
      content: seoData?.customSeoMetaDescription
        ? seoData?.customSeoMetaDescription
        : "",
    },
    {
      property: `og:image`,
      content:
        bannerImage ||
        `${generalSettingsUrl}/wp-content/uploads/2023/04/Agile-Infoways-Logo-JPEG.jpg`,
    },
    {
      property: `og:type`,
      content: blogMeta?.length > 3 ? "article" : ogTagText,
    },
    {
      property: `og:url`,
      content: seoData?.customSeoOgUrl
        ? seoData?.customSeoOgUrl
        : location?.href,
    },
    {
      property: `og:locale`,
      content: "en_US",
    },
    {
      property: `og:site_name`,
      content: "Agile Infoways",
    },
    {
      name: `title`,
      content: seoData?.customSeoMetaTitle ? seoData?.customSeoMetaTitle : "",
    },
    {
      name: `description`,
      content: seoData?.customSeoMetaDescription
        ? seoData?.customSeoMetaDescription
        : "",
    },
    {
      property: `robots`,
      // content: `${seoData?.metaRobotsNofollow},${seoData?.metaRobotsNoindex}` ? `${seoData?.metaRobotsNofollow},${seoData?.metaRobotsNoindex}` : `${seoData?.metaRobotsNofollow},${seoData?.metaRobotsNoindex}`
      content: seoData?.customSeoRobotFollow
        ? `${seoData?.customSeoRobotFollow}, ${seoData?.customSeoRobotIndex}`
        : "",
    },
    {
      property: `keywords`,
      content: seoData?.customSeoKeywords ? seoData?.customSeoKeywords : "",
    },
    {
      name: `twitter:title`,
      // content: seoData.twitterTitle ? seoData.twitterTitle : detail?.[0].seo_twitter_title
      content: seoData?.customSeoMetaTitle ? seoData?.customSeoMetaTitle : "",
    },
    {
      name: `twitter:card`,
      content: "summary_large_image",
      // content: seoData.twitterTitle ? seoData.twitterTitle : detail?.[0].seo_twitter_title
    },
    {
      name: `twitter:description`,
      // content: seoData?.twitterDescription ? seoData?.twitterDescription : detail?.[0].seo_twitter_description
      content: seoData?.customSeoMetaDescription
        ? seoData?.customSeoMetaDescription
        : "",
    },
    {
      name: `msapplication-TileImage`,
      content: "/images/favicon-32x32.ico",
    },
    {
      name: `google-site-verification`,
      content: process.env.GATSBY_GOOGLE_SITE_VERIFICATION,
    },
  ])

  useEffect(() => {
    if (location?.origin?.includes(process.env.GATSBY_SITE_URL)) {
      let pushNewTag = [
        {
          name: `msvalidate.01`,
          content: process.env.GATSBY_MS_VALIDATE_ID,
        },
      ]
      setMetaTagsArr(prevArray => [...prevArray, ...pushNewTag])
    }
  }, [seoData])

  useEffect(() => {
    setTimeout(
      function () {
        const script = document.createElement("script")
        script.async = "true"
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${process.env.GATSBY_GOOGLE_TAG_MANAGER}');`
        document.getElementsByTagName("head")[0].appendChild(script)
      },
      window?.innerWidth > 700 ? 1200 : 2300
    )

    setTimeout(
      function () {
        const script = document.createElement("script")
        script.async = "true"
        script.innerHTML = `   (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", '${process.env.GATSBY_CLARITY}');`
        document.getElementsByTagName("head")[0].appendChild(script)
      },
      window?.innerWidth > 700 ? 1200 : 1800
    )
  }, [])

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={seoData?.customSeoMetaTitle}
      meta={metaTagsArr?.concat(meta)}
    >
      {/* Static Schema as per given by SEO team */}

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "Agile Infoways LLC",
            "image": [
             "https://www.agileinfoways.com/images/agile-logo-black.svg"
             ],
            "description": "Agile Infoways is a top product engineering and web development company in the USA and India. We offer creative digital solutions to startups and enterprise clients. Get a Quote Now!.",
            "brand": {
              "@type": "Brand",
              "name": "Agile Infoways LLC"
            },
            "review": {
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": 4.2,
                "bestRating": 5
              },
              "author": {
                "@type": "Person",
                "name": "Agile Infoways LLC"
              }
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": 4.2,
              "reviewCount": 500
            }
        }`}
      </script>

      <script>
        {`
          var dataTrafficGuard = dataTrafficGuard || [];
          dataTrafficGuard.push(['property', 'tg-017006-001']);
          dataTrafficGuard.push(['event','pageview']);
          (function() {
            var tg = document.createElement('script'); 
            tg.type = 'text/javascript'; 
            tg.async = true; 
            tg.src = '//tgtag.io/tg.js?pid=tg-017006-001';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(tg, s);
          })();
        `}
      </script>
      <noscript>{`
        <img src="//p.tgtag.io/event?property_id=tg-017006-001&event_name=pageview&no_script=1" 
             width="1" height="1" border="0" alt="TrafficGuard"/>
      `}</noscript>

      {/* extra script added for google ads for two pages as per SEO team asked  */}
      {seoData?.isHireMobilePage && (
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${trackingIdForHireAndDedicatedPage}`}
        ></script>
      )}
      {seoData?.isHireMobilePage && (
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${trackingIdForHireAndDedicatedPage}');
          `}
        </script>
      )}
      {/* extra script added for google ads for two pages as per SEO team asked  */}

      {schemaAsString && (
        <script type="application/ld+json">{schemaAsString}</script>
      )}
      {faqSchemaString ? (
        <script type="application/ld+json">{faqJson}</script>
      ) : (
        ""
      )}
      {seoData?.customPageSchema ? (
        <script type="application/ld+json">
          {`${seoData?.customPageSchema}`}
        </script>
      ) : (
        ""
      )}
      {
        <script type="application/ld+json">
          {JSON.stringify(LocalBusiness)}
        </script>
      }
      {/*  This is particularly used for blog pages only  */}
      {blogSchema && (
        <script type="application/ld+json">{JSON.stringify(blogSchema)}</script>
      )}
      <link rel="icon" href="/images/favicon-32x32.ico" type="image/x-icon" />
      <link
        rel="shortcut icon"
        href="/images/favicon-32x32.ico"
        type="image/x-icon"
      />
      <link
        rel="canonical"
        href={
          seoData?.customSeoOgUrl ? seoData?.customSeoOgUrl : location?.href
        }
      />

    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default memo(Seo)
